<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  async created() {
    this.getCityGeolocation()
    this.getCarPrizeList();
  },
  computed: {
    ...mapState('user', ['uid']),
  },
  mounted() {
    const shareData = {
      title: '攒积分兑换现金红包',
      desc: '最高可得88元红包，现金直接到账余额哦~',
      link: `${window.location.origin}${process.env.VUE_APP_BASE_URL}/index`,
      imgUrl: 'https://w-cdn.pangku.com/uploads/alipay/filev2/activity/upload/2021042116120909838128713232.jpg',
    };
    this.generateShareLink(shareData);
  },
  watch: {
    uid: {
      handler() {
        this.inviteFriend();
      },
    },
  },
  methods: {
    ...mapActions('city', ['getCityGeolocation']),
    ...mapActions('user', ['inviteFriend']),
    ...mapActions('shareLink', ['generateShareLink']),
    ...mapActions('clue', [
      'getCarPrizeList',
    ]),
  },
};
</script>

